export default {
  smallMargin: 8,
  baseMargin: 16,
  doubleBaseMargin: 32,
  horizontalLineHeight: StyleSheet.hairlineWidth,
  tabBarHeight: 49,
  borderRadius: 5
};
